<template>
	<div id="checks-root" class="checks-root">
		CHECKS ROOT COMPONENT
	</div>
</template>

<script>
export default {
	name: 'ChecksRootComponent',
	props: {},
	components: {},
	data() {
		return {}
	},
	computed: {},
	created() {},
	mounted() {},
	beforeUnmount() {},
	methods: {},
	watch: {}
}
</script>

<style lang="less" scoped>
#checks-root {

}
</style>
